import type BaseEnumType from "@/app/services/baseEnumType";
import type { Maybe } from "@/components/utils/typeHelpers";

export class EnumStockType implements BaseEnumType {
  private static allValues: EnumStockType[] = []; // make sure this is top-most

  public static all = new EnumStockType(
    0,
    "All",
    "enum_stock_take_stock_type_all"
  );
  public static materials = new EnumStockType(
    1,
    "Materials",
    "enum_stock_take_stock_type_materials"
  );
  public static products = new EnumStockType(
    2,
    "Products",
    "enum_stock_take_stock_type_products"
  );

  public key: number;
  public value: string;
  public translationKey?: string;

  private constructor(key: number, value: string, translationKey?: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockType.allValues.push(this);
  }

  public equals(other: Maybe<EnumStockType>): boolean {
    return this.key === other?.key;
  }

  public isAll() {
    return this.equals(EnumStockType.all);
  }
  public isMaterials() {
    return this.equals(EnumStockType.materials);
  }
  public isProducts() {
    return this.equals(EnumStockType.products);
  }

  public static getValues(): EnumStockType[] {
    return EnumStockType.allValues;
  }

  public static getByKey(key: number): EnumStockType {
    const found = EnumStockType.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockType - Key not found: ${key}`);
    }

    return found;
  }
}
